module.exports = (__webpack_require__(0))(181);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/layout/HeaderUserView.js from dll-reference girder_lib
// module id = 45
// module chunks = 0